module.exports = __webpack_public_path__ + "img/bg_avatar_female_01.9cf1cd62.png";